module.exports = __webpack_public_path__ + "img/fondo-banner-principal.dc89bedf.png";